<template>
  <v-container>
    <v-row align="center">
      <v-col cols="2">
        <BaseSelect
          class="tab-select"
          label="Marca"
          v-model="selectedMarca"
          :items="marcas"
          hide-details
          @change="triggerFetchModeloArmas($event)"
        />
      </v-col>
      <v-col cols="2">
        <BaseSelect
          class="tab-select"
          label="Modelo"
          v-model="selectedModelo"
          :items="catalogoModeloArma"
          hide-details
          @change="triggerConsultaMovimientos($event)"
        />
      </v-col>
      <v-spacer></v-spacer>
      <v-col align="right">
        <TextButton @click="openRegistroMovimientoDialog"> REGISTRAR MOVIMIENTO </TextButton>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary" :loading="loading">
          <v-card-title>
            <div class="text-h6">Movimientos de arma</div>
            <v-spacer></v-spacer>
            <v-alert color="secondary" class="white--text mr-2" v-if="!loading">
              Disponibles: {{ getDisponibles }}
            </v-alert>
          </v-card-title>
          <v-card-text>
            <div cols="12" align="right" class="mb-2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <IconButton variant="secondary" icon="mdi-download" @click="descargarCsv" />
                  </span>
                </template>
                <span>Descargar CSV</span>
              </v-tooltip>
            </div>
            <v-data-table :headers="headers" class="transparent" :items="filteredMovimientos">
              <template v-slot:[`item.fk_idcatTipoMovimiento`]="{ item }">
                <div v-if="item.fk_idcatTipoMovimiento == 1" class="text-body-2">Entrada</div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseSelect from '../../../base/BaseSelect.vue'
import TextButton from '../../../base/TextButton.vue'
import IconButton from '../../../base/IconButton.vue'
import { DIALOG_TYPES } from '@/plugins/dialog-types.js'
import downloadCsv from '@/utils/downloadCsv'

export default {
  components: {
    BaseSelect,
    TextButton,
    IconButton,
  },
  async mounted() {
    await this.fetchMovimientoArma()
  },
  data() {
    return {
      loading: false,
      selectedMarca: null,
      selectedModelo: null,
      DIALOG_TYPES,

      headers: [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Tipo de movimiento', value: 'fk_idcatTipoMovimiento' },
        { text: 'Modelo', value: 'CatModelo.modelo' },
        { text: 'Cantidad', value: 'cantidad' },
      ],
    }
  },
  computed: {
    ...mapGetters('marcaArma', {
      marcas: 'getMarcaArma',
    }),

    ...mapGetters('modeloArma', {
      modeloArma: 'getModelosArmas',
      catalogoModeloArma: 'getCatalogoModeloArma',
    }),

    ...mapGetters('movimientoArma', {
      movimientoArma: 'getMovimientoArma',
      movimientoArmaDisponibles: 'getMovimientoArmaDisponibles',
    }),

    filteredMovimientos: function () {
      return this.movimientoArma.filter((movimiento) => {
        return movimiento.fk_idCatModelo == this.selectedModelo
      })
    },

    getDisponibles: function () {
      if (this.loading || !this.selectedModelo) {
        return 0
      } else return this.movimientoArmaDisponibles[0].disponibles
    },
  },
  methods: {
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('movimientoArma', ['fetchMovimientoArmaDisponibles', 'fetchMovimientoArma']),

    async triggerConsultaMovimientos() {
      this.loading = true
      await this.fetchMovimientoArmaDisponibles(this.selectedModelo)
      this.loading = false
    },

    async triggerFetchModeloArmas(event) {
      this.loading = true
      this.selectedModelo = null
      await this.fetchModeloArmas(event)
      this.loading = false
    },
    openRegistroMovimientoDialog() {
      this.SET_DIALOG(DIALOG_TYPES.REGISTRO_MOVIMIENTO_ARMA)
    },

    descargarCsv() {
      const data = this.filteredMovimientos.map((movimiento) => ({
        Fecha: movimiento?.fecha || '',
        'Tipo de movimiento':
          movimiento?.fk_idcatTipoMovimiento == 1 ? 'Entrada' : movimiento?.fk_idcatTipoMovimiento || '',
        Marca: movimiento?.CatModelo?.CatMarca?.title || '',
        Modelo: movimiento?.CatModelo?.modelo || '',
        Cantidad: movimiento?.cantidad || '',
      }))
      downloadCsv(data, { filename: 'movimientos-armas' })
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para MovimientosTabContent */
.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.ui-module-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 48px rgba(108, 92, 231, 0.3);
  border-color: rgba(108, 92, 231, 0.4);
}

/* Título */
::v-deep .v-card-title {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.text-h6 {
  color: #e0e0e0 !important;
  font-weight: 600;
}

/* Alert */
::v-deep .v-alert {
  background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%) !important;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(108, 92, 231, 0.3);
}

/* Tabla de datos */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  border-radius: 12px;
}

::v-deep .v-data-table__wrapper {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .v-data-table-header {
  background: linear-gradient(180deg, rgba(108, 92, 231, 0.15) 0%, rgba(108, 92, 231, 0.08) 100%) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  letter-spacing: 1px;
  border-bottom: 2px solid rgba(108, 92, 231, 0.3) !important;
  padding: 16px !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.2s ease;
  cursor: pointer;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(108, 92, 231, 0.12) !important;
  transform: scale(1.005);
  box-shadow: 0 2px 8px rgba(108, 92, 231, 0.2);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(108, 92, 231, 0.08) !important;
  padding: 14px 16px !important;
  font-size: 0.9375rem;
}

::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(108, 92, 231, 0.2) !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

/* Texto del cuerpo */
.text-body-2 {
  color: #e0e0e0 !important;
}

/* Selectores de filtros */
::v-deep .tab-select .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  min-height: 48px !important;
}

::v-deep .tab-select .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .tab-select .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .tab-select.v-input--is-focused .v-input__control,
::v-deep .tab-select .v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .tab-select input,
::v-deep .tab-select .v-label,
::v-deep .tab-select .v-select__selection,
::v-deep .tab-select .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .tab-select .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
  font-weight: 500;
}

::v-deep .tab-select.v-input--is-focused .v-label,
::v-deep .tab-select .v-input--is-focused .v-label,
::v-deep .tab-select .v-label--active {
  color: #a29bfe !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  color: #6c5ce7 !important;
}

/* Menu del select */
::v-deep .v-menu__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

::v-deep .v-list {
  background: transparent !important;
  padding: 8px !important;
}

::v-deep .v-list-item {
  border-radius: 8px;
  margin: 2px 0;
  transition: all 0.2s ease;
}

::v-deep .v-list-item:hover {
  background: rgba(108, 92, 231, 0.15) !important;
  transform: translateX(4px);
}

::v-deep .v-list-item--active {
  background: rgba(108, 92, 231, 0.25) !important;
  color: #a29bfe !important;
}

::v-deep .v-list-item__title {
  color: #e0e0e0 !important;
}

/* Loading state */
::v-deep .v-progress-linear {
  border-radius: 8px;
}

::v-deep .v-progress-linear__background {
  background: rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-progress-linear__determinate {
  background: linear-gradient(90deg, #6c5ce7 0%, #a29bfe 100%) !important;
  box-shadow: 0 0 12px rgba(108, 92, 231, 0.5);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}
</style>
